import { useCallback, useContext, useEffect, useState } from "react";
import FilterReusableComp from "../../../../components/FilterReusableComp";
import SettingLayout from "../SettingLayout";
import "../../../../styles/dashboard/setting/SettingLayout.css";
import { RazorTable, RazorTableRow } from "../../../../components/razor-reuse";
import ExchangeCurrencyText from "../../../../components/fragment/cur-text/ExchangeCurrencyText";
import TitleTextFragment from "../../../../components/fragment/title-text/TitleTextFragment";
import PaginationFragment from "../../../../components/fragment/pagination/PaginationFragment";
import AddExchangeRateModal from "./AddExchangeRateModal";
import EditExchangeRateModal from "./EditExchangeRateModal";
import DeleteRateModal from "./DeleteRateModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCurrencies,
  getAllExchangeRate,
} from "../../../../redux/settings";
import RootState from "../../../../redux/type";
import TextColorFragment from "../../../../components/fragment/text-color/TextColorFragment";
import DotActionDropFragment from "../../../../components/fragment/actionIconFragment/DotActionDropFragment";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../../routes/AllRoutes";
import { systemRoles } from "../../../../utils/roles";
import { formatTime } from "../../../../utils/Helper";
import ActionContext from "../../../../context/ActionContext";

const ExchangeRateIndex = () => {
  const { loading, all_currencies_drop, exchange_rates } = useSelector(
    (state: RootState) => state.settings
  );
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  const actionCtx = useContext(ActionContext);
  const [currentPageVal, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const tableHeaderList = [
    "Currency Pair",
    "Rate User",
    "Eff. Rate",
    "Provider",
    "Updated By",
    "Date",
    "Status",
    "Action",
  ];

  const [singleChild, setSingleChild] = useState({});
  type modalProps = {
    add: boolean;
    edit: boolean;
    delete: boolean;
  };

  const [showModal, setShowModal] = useState<modalProps>({
    add: false,
    edit: false,
    delete: false,
  });

  useEffect(() => {
    if (all_currencies_drop?.length < 1) {
      dispatch(getAllCurrencies({} as any) as any);
    }
  }, [all_currencies_drop?.length, dispatch]);

  const selectListTwo = [
    { label: "Active", value: "active" },
    { label: " Inactive", value: "inactive" },
    { label: "All ", value: "" },
  ];
  const [filterTwoVal, setFilterTwoVal] = useState<any>("");

  const [refreshtable, setRefreshTable] = useState<boolean>(false);

  useEffect(() => {
    const obj = {
      page: currentPageVal,
      status: filterTwoVal?.value || "",
      search: "",
    };
    if (
      user?.permissions?.includes(systemRoles[26]) &&
      user?.permissions?.length > 0
    ) {
      dispatch(getAllExchangeRate(obj as any) as any);
    }
  }, [refreshtable, currentPageVal, filterTwoVal, user?.permissions, dispatch]);

  const triggerCollapse = useCallback(() => {
    if (!actionCtx?.collapse) actionCtx?.setCollapse?.();
  }, [actionCtx]);

  useEffect(() => {
    triggerCollapse();
  }, []);

  const handleFinish = () => {
    setShowModal((prev) => {
      return { ...prev, add: false, edit: false, delete: false };
    });
    setRefreshTable(!refreshtable);
  };

  const actionList = [
    {
      //   icon: ALL_ICONS?.edit,
      label: "View",
      onClick: (param?: any) => {
        localStorage.setItem("cur-his-id", param?.id);
        navigate(ALL_ROUTES?.DASHBOARD_SETTINGS_EXCHANGE_RATE_HISTORY);
      },
      textColor: "",
    },
    {
      //   icon: ALL_ICONS?.edit,
      label: "Edit",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal((prev) => {
          return { ...prev, edit: true };
        });
      },
      textColor: "",
      hide: !user?.permissions?.includes(systemRoles[27]),
    },
    {
      //   icon: ALL_ICONS?.delete,
      label: "Deactivate",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal((prev) => {
          return { ...prev, delete: true };
        });
      },
      textColor: "rgba(225, 25, 0, 1)",
      hide: !user?.permissions?.includes(systemRoles[25]),
    },
    {
      //   icon: ALL_ICONS?.delete,
      label: "Activate",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal((prev) => {
          return { ...prev, delete: true };
        });
      },
      textColor: "rgba(0, 153, 51, 1)",
      hide: !user?.permissions?.includes(systemRoles[25]),
    },
  ];

  const updateActionArray = (hideObj?: any, hideObjTwo?: any) => {
    const newList = actionList?.map((chi) => {
      return chi?.label === hideObj?.label
        ? { ...chi, hide: hideObj?.hide ? true : false }
        : { ...chi };
    });
    const secondList = newList?.map((chi) => {
      return chi?.label === hideObjTwo?.label
        ? { ...chi, hide: hideObjTwo?.hide ? true : false }
        : { ...chi };
    });
    return secondList;
  };

  const formatOptionLabelTwo = ({ label, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <TextColorFragment
            color={
              value === "active"
                ? "rgba(0, 153, 51, 1)"
                : value === "Pending"
                ? "rgba(255, 192, 67, 1)"
                : value === "inactive"
                ? "rgba(200, 16, 46, 1)"
                : ""
            }
            text={label}
          />
        </>
      );
    }
  };

  const removeSelectedList = (list: any) => {
    if (list?.length > 0) {
      // const newlist = list?.filter(
      //   (chi: any) => chi?.label !== filterOneVal?.label
      // );
      const secondlist = list?.filter(
        (chi: any) => chi?.label !== filterTwoVal?.label
      );
      return secondlist;
    }
  };

  return (
    <>
      <SettingLayout
        onBtnClick={() => {
          setShowModal((prev) => {
            return { ...prev, add: true };
          });
          // console.log(exchange_rates);
        }}
        hideBtn={loading || !user?.permissions?.includes(systemRoles[25])}
        title="Exchange Rate"
        btnLabel="Add New Exchange Rate"
        pageLoading={loading && Object?.keys(exchange_rates)?.length < 1}
      >
        <div className="exchange-rate-settings-wrap-index">
          {/* filter section start */}
          <FilterReusableComp
            className="search-reuse-box"
            hideExport
            onSearch={(param: any) => {
              if (String(param)?.length > 2) {
                const obj = {
                  search: param,
                };
                dispatch(getAllExchangeRate(obj as any) as any);
              }
              if (String(param)?.length < 1) {
                const obj = {
                  status: filterTwoVal?.value,
                };
                dispatch(getAllExchangeRate(obj as any) as any);
              }
            }}
            searchPlaceholder="Search for currency"
            onSelectTwo={(param) => {
              setFilterTwoVal(param);
            }}
            formatOptionLabelTwo={formatOptionLabelTwo}
            selectTwoValue={filterTwoVal}
            defaultSelectTwo="Rate Status"
            selectTwoList={removeSelectedList(selectListTwo)}
          />
          {/* filter section end */}
          {/* table start */}
          <div className="table-section-box">
            <RazorTable className="w-full" headerList={tableHeaderList}>
              {exchange_rates?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    key={idx}
                    one={
                      <ExchangeCurrencyText
                        curOne={chi?.source_currency?.code || "NIL"}
                        curTwo={chi?.destination_currency?.code || "NIL"}
                        urlOne={
                          chi?.source_currency?.code === "USD"
                            ? ""
                            : chi?.source_currency?.code === "EUR"
                            ? ""
                            : chi?.source_currency?.code === "GBP"
                            ? ""
                            : chi?.source_currency?.code === "NGN"
                            ? ""
                            : chi?.source_currency?.logo
                        }
                        urlTwo={
                          chi?.destination_currency?.code === "USD"
                            ? ""
                            : chi?.destination_currency?.code === "EUR"
                            ? ""
                            : chi?.destination_currency?.code === "GBP"
                            ? ""
                            : chi?.destination_currency?.code === "NGN"
                            ? ""
                            : chi?.destination_currency?.logo
                        }
                      />
                    }
                    two={
                      chi?.rate_user_type === "customer"
                        ? "Mobile"
                        : chi?.rate_user_type || "---"
                    }
                    three={chi?.rate || "---"}
                    onRowClick={() => {
                      // console.log(chi);
                      localStorage.setItem("cur-his-id", chi?.id);
                      navigate(
                        ALL_ROUTES?.DASHBOARD_SETTINGS_EXCHANGE_RATE_HISTORY
                      );
                    }}
                    five={
                      <TitleTextFragment
                        titleSize="1.25rem"
                        // text={chi?.updated_by?.email || ""}
                        title={`${chi?.updated_by?.first_name || ""} ${
                          chi?.updated_by?.last_name || ""
                        }`}
                        // textColor='red'
                      />
                    }
                    four={
                      chi?.provider === "exchange-rate-api"
                        ? "Ex Rate"
                        : "Aboki Fx"
                    }
                    six={
                      // <RazorDateTime date={chi?.updated_at} />
                      <>
                        {formatTime(chi?.updated_at)?.split(",")?.[0]}
                        <p>{formatTime(chi?.updated_at)?.split(",")?.[1]}</p>
                      </>
                      // chi?.updated_at
                      //   ? formatTime(chi?.updated_at || "")
                      //   : "---"
                    }
                    seven={
                      <TextColorFragment
                        color={
                          chi?.status === "active"
                            ? "rgba(0, 153, 51, 1)"
                            : chi?.status === "Pending"
                            ? "rgba(255, 192, 67, 1)"
                            : chi?.status === "inactive"
                            ? "rgba(200, 16, 46, 1)"
                            : ""
                        }
                        text={chi?.status}
                      />
                    }
                    eight={
                      <DotActionDropFragment
                        list={updateActionArray(
                          {
                            hide:
                              chi?.status === "inactive" ||
                              !user?.permissions?.includes("set_exchange_rate"),
                            label: "Deactivate",
                          },
                          {
                            hide:
                              chi?.status !== "inactive" ||
                              !user?.permissions?.includes("set_exchange_rate"),
                            label: "Activate",
                          }
                        )}
                        detail={chi}
                      />
                    }
                    loading={loading}
                  />
                );
              })}
            </RazorTable>
          </div>
          {/* table end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={exchange_rates?.meta?.current_page || 1}
            perPage={exchange_rates?.meta?.per_page}
            totalPage={exchange_rates?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading}
          />
          {/* pagination  end */}
        </div>
      </SettingLayout>
      {/* modal start */}
      <AddExchangeRateModal
        visible={showModal?.add}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, add: false };
          });
        }}
        onFinish={handleFinish}
      />
      <EditExchangeRateModal
        visible={showModal?.edit}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, edit: false };
          });
        }}
        detail={singleChild}
        onFinish={handleFinish}
      />
      <DeleteRateModal
        visible={showModal?.delete}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, delete: false };
          });
        }}
        detail={singleChild}
        onFinish={handleFinish}
      />
      {/* modal end */}
    </>
  );
};

export default ExchangeRateIndex;
